<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/SOTL_contents">Abbreviations</a></h1>
<p class="abb_fo">4Q265 – <em class="italic">4QMiscellaneous Rules</em> (Dead Sea Scrolls)</p>
<p class="abb_fo">4Q418 frag. 81 – <em class="italic">4QInstruction</em><span class="sup_roman">d</span> (Dead Sea Scrolls)</p>
<p class="abb_fo">4Q423 – <em class="italic">4QInstruction</em> (Dead Sea Scrolls)</p>
<p class="abb_fo">4Q423 frag. 2 – <em class="italic">4QInstruction</em> (Dead Sea Scrolls)</p>
<p class="abb_fo">4Q423 8+24 – <em class="italic">4QInstruction</em><span class="sup_roman">d</span> (Dead Sea Scrolls)</p>
<p class="abb_fo">4Q504 – <em class="italic">4QWords of the Luminaries</em> (Dead Sea Scrolls)</p>
<p class="abb_fo">4Q504 frag. 8 – <em class="italic">4QWords of the Luminaries</em> (Dead Sea Scrolls)</p>
<p class="abb_fo">4QIsa<span class="sup_roman">a</span> – <em class="italic">4QIsaiah</em><span class="sup_roman">a </span>(Dead Sea Scrolls)</p>
<p class="abb_fo">4QIsa<span class="sup_roman">b</span> – <em class="italic">4QIsaiah</em><span class="sup_roman">b </span>(Dead Sea Scrolls)</p>
<p class="abb_fo">4QIsa<span class="sup_roman">d</span> – <em class="italic">4QIsaiah</em><span class="sup_roman">d </span>(Dead Sea Scrolls)</p>
<p class="abb_fo">AB – Anchor Bible</p>
<p class="abb_fo">ANTJ – Arbeiten zum Neuen Testament und Judentum</p>
<p class="abb_fo">AT – author’s translation</p>
<p class="abb_fo">B – Codex Vaticanus</p>
<p class="abb_fo"><em class="italic">b. Meg.</em> – Babylonian Talmud Tractate <em class="italic">Megillah </em></p>
<p class="abb_fo"><em class="italic">b. Ned.</em> – Babylonian Talmud Tractate <em class="italic">Nedarim </em></p>
<p class="abb_fo"><em class="italic">b. Sabb.</em> – Babylonian Talmud Tractate <em class="italic">Shabbat </em></p>
<p class="abb_fo"><em class="italic">b. Sanh.</em> – Babylonian Talmud Tractate <em class="italic">Sanhedrin </em></p>
<p class="abb_fo"><em class="italic">BA – The Biblical Archaeologist </em></p>
<p class="abb_fo"><em class="italic">BBR – Bulletin for Biblical Research </em></p>
<p class="abb_fo">BDAG – W. Bauer, F. W. Danker, W. F. Arndt and W. F. Gingrich, <em class="italic">A Greek-English Lexicon of the New Testament and Other Early Christian Literature</em>, 3rd edn, Chicago: University of Chicago Press, 2000</p>
<p class="abb_fo">BDB – <em class="italic">The New Brown-Diver-Briggs-Gesenius Hebrew and English Lexicon</em>, ed. F. Brown, Peabody: Hendrickson, 1979</p>
<p class="abb_fo">BECNT – Baker Exegetical Commentary on the New Testament</p>
<p class="abb_fo">BETL – Bibliotheca ephemeridum theologicarum lovaniensium</p>
<p class="abb_fo">BHT – Beiträge zur historischen Theologie</p>
<p class="abb_fo"><em class="italic">Bib – Biblica </em></p>
<p class="abb_fo"><em class="italic">BN – Biblische Notizen </em></p>
<p class="abb_fo">BNTC – Black’s New Testament Commentary</p>
<p class="abb_fo"><em class="italic">BT – The Bible Translator </em></p>
<p class="abb_fo">BTCP – Biblical Theology for Christian Proclamation</p>
<p class="abb_fo">BZAW – Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft</p>
<p class="abb_fo">BZNW – Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</p>
<p class="abb_fo">c. – circa</p>
<p class="abb_fo">CBET – Contributions to Biblical Exegesis and Theology</p>
<p class="abb_fo"><em class="italic">CBQ – Catholic Biblical Quarterly </em></p>
<p class="abb_fo">CBQMS – Catholic Biblical Quarterly Monograph Series</p>
<p class="abb_fo"><em class="italic">COS</em> – <em class="italic">The Context of Scripture</em>, ed. W. W. Hallo. 3 vols., Leiden: Brill, 1997–</p>
<p class="abb_fo"><span class="smallcaps">csb</span> – Christian Standard Bible</p>
<p class="abb_fo">D* – Codex Bezae</p>
<p class="abb_fo"><em class="italic">DCH – Dictionary of Classical Hebrew</em>, D. J. A. Clines, Sheffield; Sheffield Academic Press, 1993–2011</p>
<p class="abb_fo">DPL – <em class="italic">Dictionary of Paul and His Letters</em>, ed. G. F. Hawthorne and R. P. Martin, Downers Grove: InterVarsity Press, 1993</p>
<p class="abb_fo">EBC – The Expositor’s Bible Commentary, ed. F. E. Gaebelein, Grand Rapids: Zondervan</p>
<p class="abb_fo">ESBT – Essential Studies in Biblical Theology</p>
<p class="abb_fo"><span class="smallcaps">esv</span> – English Standard Version</p>
<p class="abb_fo"><em class="italic">EvQ – Evangelical Quarterly </em></p>
<p class="abb_fo">FRLANT – Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p>
<p class="abb_fo">GHAT – Göttingen Handkommentar zum Alten Testament</p>
<p class="abb_fo"><em class="italic">HALOT</em> – <em class="italic">The Hebrew and Aramaic Lexicon of the Old Testament</em>, L. Koehler and W. Baumgartner, Leiden; Brill, 1994–2000</p>
<p class="abb_fo">HBM – Hebrew Biblical Monographs</p>
<p class="abb_fo">ICC – International Critical Commentary</p>
<p class="abb_fo"><em class="italic">IEJ – Israel Exploration Journal </em></p>
<p class="abb_fo"><em class="italic">JANER – Journal of Ancient Near Eastern Religions </em></p>
<p class="abb_fo"><em class="italic">JBL – Journal of Biblical Literature </em></p>
<p class="abb_fo"><em class="italic">JETS – Journal of the Evangelical Theological Society </em></p>
<p class="abb_fo"><em class="italic">JSNT – Journal for the Study of the New Testament </em></p>
<p class="abb_fo">JSNTSup – Journal for the Study of the New Testament, Supplement Series</p>
<p class="abb_fo">JSOTSup – Journal for the Study of the Old Testament, Supplement Series</p>
<p class="abb_fo"><em class="italic">JSPL – Journal for the Study of Paul and His Letters </em></p>
<p class="abb_fo">LNTS – Library of New Testament Studies</p>
<p class="abb_fo"><span class="smallcaps">lxx</span> – Septuagint</p>
<p class="abb_fo"><span class="smallcaps">mt</span> – Masoretic Text</p>
<p class="abb_fo">NAC – New American Commentary</p>
<p class="abb_fo"><span class="smallcaps">nasb</span> – New American Standard Bible</p>
<p class="abb_fo"><span class="smallcaps">nets</span> – New English Translation of the Septuagint</p>
<p class="abb_fo">NICNT – New International Commentary on the New Testament</p>
<p class="abb_fo">NICOT – New International Commentary on the Old Testament</p>
<p class="abb_fo"><em class="italic">NIDNTT</em> – <em class="italic">The New International Dictionary of New Testament Theology</em>, C. Brown, 4 vols.﻿, Grand Rapids: Regency Reference Library, 1986</p>
<p class="abb_fo"><em class="italic">NIDNTTE</em> – <em class="italic">New International Dictionary of New Testament Theology and Exegesis</em>, ed. M. S. Silva, 2nd edn, Grand Rapids: Zondervan, 2014</p>
<p class="abb_fo"><em class="italic">NIDOTTE</em> – <em class="italic">New International Dictionary of Old Testament Theology and Exegesis</em>, ed. W. A. VanGemeren, Grand Rapids: Zondervan, 1997</p>
<p class="abb_fo">NIGTC – New International Greek Testament Commentary</p>
<p class="abb_fo"><span class="smallcaps">niv</span> – New International Version</p>
<p class="abb_fo">NovTSup – Supplements to Novum Testamentum</p>
<p class="abb_fo">NSBT – New Studies in Biblical Theology</p>
<p class="abb_fo">NT – New Testament</p>
<p class="abb_fo"><em class="italic">NTS – New Testament Studies </em></p>
<p class="abb_fo">OT – Old Testament</p>
<p class="abb_fo">OTL – Old Testament Library</p>
<p class="abb_fo"><span class="papyrus">𝔓</span><span class="sup_roman">75</span> – Papyrus 75</p>
<p class="abb_fo">PNTC – Pillar New Testament Commentary</p>
<p class="abb_fo">Q – Codex Guelferbytanus B</p>
<p class="abb_fo">SBLMS – Society of Biblical Literature Monograph Series</p>
<p class="abb_fo">SBTS – Sources for Biblical and Theological Study</p>
<p class="abb_fo">SCHT – Studies in Christian History and Thought</p>
<p class="abb_fo">SHM – Studies in the History of Missions</p>
<p class="abb_fo">SNTMS – Society for New Testament Studies Monograph series</p>
<p class="abb_fo">SubBi – Subsidia Biblica</p>
<p class="abb_fo">s.v. – (sub verbo) under the heading or word given</p>
<p class="abb_fo"><em class="italic">Tg. Ps.-J. – Targum Pseudo-Jonathan </em></p>
<p class="abb_fo"><em class="italic">T. Jos.</em> – <em class="italic">Testament of Joseph </em></p>
<p class="abb_fo"><em class="italic">TDNT</em> – <em class="italic">Theological Dictionary of the New Testament</em>, ed. G. Kittel and G. Friedrich, tr. G. W. Bromiley, 10 vols., Grand Rapids: Eerdmans, 1964–76.</p>
<p class="abb_fo">TNTC – Tyndale New Testament Commentaries</p>
<p class="abb_fo">TOTC – Tyndale Old Testament Commentaries</p>
<p class="abb_fo"><em class="italic">TWOT</em> – <em class="italic">Theological Wordbook of the Old Testament</em>, ed. R. L. Harris, G. L. Archer Jr, 2 vols.﻿, Chicago: Moody, 1980</p>
<p class="abb_fo">tr. – translation, translated by</p>
<p class="abb_fo"><em class="italic">TrinJ – Trinity Journal </em></p>
<p class="abb_fo"><em class="italic">TynB – Tyndale Bulletin </em></p>
<p class="abb_fo"><em class="italic">UF – Ugarit-Forschungen </em></p>
<p class="abb_fo"><em class="italic">VT – Vetus Testamentum </em></p>
<p class="abb_fo">VTSup – Supplements to Vetus Testamentum</p>
<p class="abb_fo">W – Codex Washington</p>
<p class="abb_fo">WBC – Word Biblical Commentary</p>
<p class="abb_fo">WMANT – Wissenschaftliche Monographien zum Alten und Neuen Testament</p>
<p class="abb_fo"><em class="italic">WTJ – Westminster Theological Journal </em></p>
<p class="abb_fo">WUNT – Wissenschaftliche Untersuchungen zum Neuen Testament</p>
<p class="abb_fo">ZECNT – Zondervan Exegetical Commentary on the New Testament</p>
<p class="abb_fo"><em class="italic">ZNW – Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche </em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SOTL_abbrev.vue?71e20ebc